import { NavLink, Outlet } from "react-router-dom";
import type { Me } from "./api";

export function Layout({ me, onSignOut }: { me: Me; onSignOut: () => void }) {
  return (
    <div className="shell">
      <header className="topbar">
        <img className="topbar__mark" src="/brand/logo-mark.png" alt="" />
        <span className="topbar__title">TimeSaver Offsite</span>

        <nav className="topbar__nav">
          <NavLink to="/meetings">Meetings</NavLink>
          <NavLink to="/clients">Clients</NavLink>
          {me.role === "admin" && <NavLink to="/users">Users</NavLink>}
          <NavLink to="/account">Account</NavLink>
        </nav>

        <div className="topbar__me">
          <span className="topbar__name">{me.name}</span>
          {me.role === "admin" && <span className="pill">Admin</span>}
          <button className="linkbtn" onClick={onSignOut}>Sign out</button>
        </div>
      </header>

      <main className="content">
        <Outlet />
      </main>
    </div>
  );
}
